module.exports = __webpack_public_path__ + "img/osk1.01fd496c.png";